import * as httpx from "httpx"
import { CancellablePromise } from "real-cancellable-promise"

import {
	SubmitRequest,
	SubmitResponse,
	PreviewResponse,
	EmailOptions,
	FeedbackItem,
	FeedbackHistoryItem,
	FeedbackHistorySubmission,
	FeedbackHistoryResponse,
	Category,
} from "brandguard/feedback/brandguard.feedback_pb"

export {
	SubmitRequest,
	SubmitResponse,
	PreviewResponse,
	EmailOptions,
	FeedbackItem,
	FeedbackHistoryItem,
	FeedbackHistorySubmission,
	FeedbackHistoryResponse,
	Category,
}

export type AssetType = "image" | "text" | "document" | "video"
export type ClientAction = "submit" | "copy" | "email"

export function submit(req: SubmitRequest, ...options: httpx.option[]): CancellablePromise<SubmitResponse> {
	return httpx.post<SubmitResponse>(`${httpx.urlstorage.host()}/bg/feedback/submit`, req, ...options)
}

export function history(
	eventType: AssetType,
	eventId: string,
	...options: httpx.option[]
): CancellablePromise<FeedbackHistoryResponse> {
	return httpx.get<FeedbackHistoryResponse>(
		`${httpx.urlstorage.host()}/bg/feedback/history`,
		{ event_type: eventType, event_id: eventId },
		...options,
	)
}
